<template>
  <div>
    <e-table-list
      :table-data="this.evaluationInfo.evaluationProductList || []"
      :table-label="tableLabel"
    >
    </e-table-list>
    <div class="down-block">
      <div class="single-down">
        <div class="single-down-line">
          <div class="parm" @click="showTable()">产品质量评价办法：</div>
          <div class="file-name">易派客工业品质量评价办法（复印纸）.pdf</div>
        </div>
      </div>
      <div class="single-down">
        <div class="single-down-line">
          <div class="parm">产品质量评价办法：</div>
          <div class="file-name">易派客工业品质量评价办法（复印纸）.pdf</div>
        </div>
      </div>

      <div class="single-down">
        <div class="single-down-line">
          <div class="parm">产品质量评价办法：</div>
          <div class="file-name">易派客工业品质量评价办法（复印纸）.pdf</div>
        </div>
      </div>

      <div class="single-down">
        <div class="single-down-line">
          <div class="parm">产品质量评价办法：</div>
          <div class="file-name">易派客工业品质量评价办法（复印纸）.pdf</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list.vue';

export default {
  props: {
    evaluationInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: this.evaluationInfo.evaluationProductList || [],
      tableLabel: [
        { label: '产品名称', param: 'productName', align: 'center' },
        { label: '初评检测费', param: 'phone', align: 'right' },
        { label: '限制范围', param: 'scopeOfApplication', align: 'center' }
      ]
    };
  },

  components: { eTableList },

  computed: {},

  created() {},
  methods: {
    showTable() {
      console.log(this.evaluationInfo.evaluationProductList);
    }
  }
};
</script>
<style lang="scss" scoped>
.down-block {
  font-size: 14px;
  color: #333;
  margin-top: 20px;
  .single-down {
    display: inline-block;
    width: 420px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .single-down-line {
      display: flex;
      justify-content: start;
      align-items: center;

      .parm {
      }
      .file-name {
        color: #0064c8;
        cursor: pointer;
      }
    }
  }
}
</style>
